var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          ref: "tableStudent",
          attrs: {
            "element-loading-spinner": "el-icon-loading",
            data: _vm.responseDataStudents,
            border: "",
            "max-height": _vm.$tableMaxHeight,
            "header-cell-style": _vm.headerCellStyle,
            "element-loading-text": _vm.$tableLoading,
            "element-loading-background": "rgba(255,255,255, 0)",
            "summary-method": _vm.getSummaries,
            "show-summary": "",
          },
          on: { "selection-change": _vm.handleSelectionChange },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-size": "16px",
                        color: "#43a0ff",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _c("span", [_vm._v(" Không có dữ liệu! ")]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              type: "selection",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              type: "index",
              label: "STT",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { fixed: "left", label: "Họ và tên", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            Mã học sinh: " +
                              _vm._s(scope.row.kidCode) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            Bố/Mẹ: " +
                              _vm._s(scope.row.fatherPhone) +
                              " - " +
                              _vm._s(scope.row.motherPhone) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(scope.row.fullName))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Biệt danh", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.nickName))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Hiển thị", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      attrs: {
                        disabled:
                          scope.row.status === null ||
                          scope.row.status === "Ẩn hóa đơn",
                      },
                      on: {
                        change: (value) =>
                          _vm.handelShowOrHidden(scope.row, value),
                      },
                      model: {
                        value: scope.row.orderHidden,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "orderHidden", $$v)
                        },
                        expression: "scope.row.orderHidden",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Thông tin bổ sung",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.category === "CLASS"
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenKidDetail(
                                  scope.row,
                                  scope.row.status
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-document" })]
                        )
                      : _vm._e(),
                    scope.row.category === "GROUP"
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenKidGroupDetail(
                                  scope.row,
                                  scope.row.status
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-document" })]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Loại học phí", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(scope.row.category === "CLASS" ? "Lớp" : "Nhóm")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Tháng tồn", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.category === "CLASS"
                      ? _c(
                          "div",
                          [
                            scope.row.numPayLate !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "click-in-row",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inventoryOrder(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.numPayLate) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.category === "GROUP"
                      ? _c(
                          "div",
                          [
                            scope.row.numPayLateGroup !== 0
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "click-in-row",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.inventoryOrderGroup(
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.numPayLateGroup) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Tên gói", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.namePackage))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Gia hạn gói", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-checkbox", {
                      on: {
                        change: (value) =>
                          _vm.handelRegisterPackage(scope.row, value),
                      },
                      model: {
                        value: scope.row.checkStatus,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "checkStatus", $$v)
                        },
                        expression: "scope.row.checkStatus",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trạng thái gói", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.tuitionStatus === "Còn hạn"
                      ? _c("span", { staticStyle: { color: "#409EFF" } }, [
                          _vm._v(_vm._s(scope.row.tuitionStatus)),
                        ])
                      : _c("span", { staticStyle: { color: "#F56C6C" } }, [
                          _vm._v(_vm._s(scope.row.tuitionStatus)),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Ngày còn lại", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            Thời gian gói: " +
                              _vm._s(_vm.formatDateTime(scope.row.startDate)) +
                              " đến " +
                              _vm._s(_vm.formatDateTime(scope.row.endDate)) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("span", [_vm._v(_vm._s(scope.row.remainDay))]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Trạng thái", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { class: _vm.getStatusColor(scope.row.status) }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getStatusValue(scope.row.status)) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Chuyển thanh toán",
              width: "140",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.transactionEntry === "MONEY_WALLET" &&
                    scope.row.afterMoney !== 0
                      ? _c("span", { staticStyle: { color: "orange" } }, [
                          _vm._v("Không chuyển"),
                        ])
                      : _vm._e(),
                    scope.row.transactionEntry === "MONEY_MONTH" &&
                    scope.row.afterMoney !== 0
                      ? _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v("Sang tháng sau"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Thiếu/thừa tháng trước",
              width: "110",
              align: "right",
              prop: "beforeMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("formatCurrency")(scope.row.beforeMoney)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Phải thu tháng này",
              width: "110",
              align: "right",
              prop: "sumMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(scope.row.sumMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Đã thu",
              width: "110",
              align: "right",
              prop: "collectedMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.category === "CLASS"
                      ? _c(
                          "div",
                          [
                            _vm.getStatusValue(scope.row.status) !==
                            "Chưa có hóa đơn"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "click-in-row",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.collectedMoneyMethod(
                                          scope.row,
                                          scope.row.status
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [
                                      scope.row.collectedMoney
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  scope.row.collectedMoney
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [_c("b", [_vm._v("-")])]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.category === "GROUP"
                      ? _c(
                          "div",
                          [
                            _vm.getStatusValue(scope.row.status) !==
                            "Chưa có hóa đơn"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "click-in-row",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.collectedMoneyGroupMethod(
                                          scope.row,
                                          scope.row.status
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("div", [
                                      scope.row.collectedMoney
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  scope.row.collectedMoney
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [_c("b", [_vm._v("-")])]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tiền mặt",
              width: "110",
              align: "right",
              prop: "cashMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(scope.row.cashMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Chuyển khoản",
              width: "120",
              align: "right",
              prop: "transferMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("formatCurrency")(scope.row.transferMoney)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Thiếu/thừa còn lại",
              width: "110",
              align: "center",
              prop: "afterMoney",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatCurrency")(scope.row.afterMoney)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.courseNames, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: { align: "right", width: "115", label: item },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: scope.column.label,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeNameRevenus(item.name)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ]
                        ),
                        scope.row.category === "CLASS"
                          ? _c("div", [
                              _vm.getStatusValue(scope.row.status) !==
                              "Chưa có hóa đơn"
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "click-in-row",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              _vm.getDetailKT(
                                                _vm.getDataIndexKt(
                                                  scope.row,
                                                  scope.column.label
                                                ),
                                                scope.row,
                                                scope.column.label,
                                                scope.row.status
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatCurrency")(
                                                    _vm.showDataListKt(
                                                      scope.row,
                                                      scope.column.label
                                                    )
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        scope.row.category === "GROUP"
                          ? _c("div", [
                              _vm.getStatusValue(scope.row.status) !==
                              "Chưa có hóa đơn"
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "click-in-row",
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              _vm.getDetailKTGroup(
                                                _vm.getDataIndexKt(
                                                  scope.row,
                                                  scope.column.label
                                                ),
                                                scope.row,
                                                scope.column.label,
                                                scope.row.status
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("formatCurrency")(
                                                    _vm.showDataListKt(
                                                      scope.row,
                                                      scope.column.label
                                                    )
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "Tác vụ",
              width: "215",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.category === "CLASS"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c("el-button", {
                              staticStyle: { display: "none" },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.getButtonCashierType(scope.row),
                                  disabled:
                                    scope.row.status === null ||
                                    scope.row.status === "Ẩn hóa đơn" ||
                                    scope.row.sumMoney === 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.orderKidsCashierMethod(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            Thanh toán\n          ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "success",
                                  size: "mini",
                                  disabled:
                                    scope.row.status === null ||
                                    scope.row.sumMoney === 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.orderKidsHistoryMethod(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            Lịch sử\n          ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.category === "GROUP"
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [
                            _c("el-button", {
                              staticStyle: { display: "none" },
                            }),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.getButtonCashierType(scope.row),
                                  disabled:
                                    scope.row.status === null ||
                                    scope.row.status === "Ẩn hóa đơn" ||
                                    scope.row.sumMoney === 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.orderKidsCashierGroupMethod(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("Thanh toán\n          ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "success",
                                  size: "mini",
                                  disabled:
                                    scope.row.status === null ||
                                    scope.row.sumMoney === 0,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.orderKidsHistoryGroupMethod(
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n            Lịch sử\n          ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("OrderKidsExcelCashier", {
        ref: "OrderKidsExcelCashier",
        attrs: {
          isOpenCashierDialog: _vm.isDialog.showOrderKidsExcelCashierDialog,
          isActivatedAccount: _vm.isActivatedAccount,
        },
        on: { "dialog-close": _vm.closeOrderKidsExcelCashierDialog },
      }),
      _c("HistoryOrderKidsDialog", {
        ref: "OrderKidsHistoryDialog",
        attrs: { isOpenHistoryDialog: _vm.isDialog.showHistoryDialog },
        on: {
          closeHistoryOrderKids: function ($event) {
            return _vm.closeOrderKidsHistoryDialog()
          },
        },
      }),
      _c("DetailKTDialog", {
        ref: "DetailKTDialog",
        attrs: { isOpenDetailKT: _vm.isDialog.showDetailKtDialog },
        on: { closeDetailKT: _vm.closeDetailKTDialog },
      }),
      _c("ExcelKidDetail", {
        ref: "ExcelKidDetail",
        attrs: {
          isOpenKidDetail: _vm.isDialog.showKidDetailDialog,
          "kids-detail-data": _vm.kidDetailData,
        },
        on: { closeDetailKid: _vm.handleCloseDetailKid },
      }),
      _c("InventoryOrderDialog", {
        ref: "InventoryOrderDialog",
        attrs: { isOpenInventoryOrder: _vm.isDialog.showInventoryOrder },
        on: { closeInventoryOrder: _vm.closeInventoryOrderDialog },
      }),
      _vm.checkPermission(["fees_2_excel_cash_payment"])
        ? _c("CollectedMoneyDialog", {
            ref: "CollectedMoneyDialog",
            attrs: { isOpenCollectedMoney: _vm.isDialog.showCollectedMoney },
            on: { closeCollectedMoney: _vm.closeCollectedMoneyDialog },
          })
        : _vm._e(),
      _c("OrderKidsExcelCashierGroup", {
        ref: "OrderKidsExcelCashierGroup",
        attrs: {
          isOpenCashierDialog:
            _vm.isDialog.showOrderKidsExcelCashierGroupDialog,
          isActivatedAccount: _vm.isActivatedAccount,
        },
        on: { "dialog-close": _vm.closeOrderKidsExcelCashierGroupDialog },
      }),
      _c("HistoryOderKidsDialogGroup", {
        ref: "OrderKidsHistoryGroupDialog",
        attrs: {
          isOpenHistoryDialogGroup: _vm.isDialog.showHistoryGroupDialog,
        },
        on: {
          closeHistoryOrderKids: function ($event) {
            return _vm.closeOrderKidsHistoryGroupDialog()
          },
        },
      }),
      _c("ExcelKidForGroupDetailDialog", {
        ref: "ExcelKidDetailGroup",
        attrs: {
          isOpenKidDetail: _vm.isDialog.showKidDetailGroupDialog,
          "kids-detail-data": _vm.kidDetailData,
        },
        on: { closeDetailKid: _vm.handleCloseDetailKidGroup },
      }),
      _c("InventoryOrderForGroupDialog", {
        ref: "InventoryOrderGroupDialog",
        attrs: { isOpenInventoryOrder: _vm.isDialog.showInventoryOrderGroup },
        on: {
          closeInventoryOrder: function ($event) {
            return _vm.closeInventoryOrderGroupDialog()
          },
        },
      }),
      _vm.checkPermission(["fees_2_excel_cash_payment"])
        ? _c("CollectedMoneyForGroupDialog", {
            ref: "CollectedMoneyDialogForGroup",
            attrs: {
              isOpenCollectedMoney: _vm.isDialog.showCollectedMoneyGroup,
            },
            on: {
              closeCollectedMoney: function ($event) {
                return _vm.closeCollectedMoneyGroupDialog()
              },
            },
          })
        : _vm._e(),
      _c("DetailKTForGroupDialog", {
        ref: "DetailKTForGroupDialog",
        attrs: { isOpenDetailKT: _vm.isDialog.showDetailKTGroupDialog },
        on: {
          closeDetailKT: function ($event) {
            return _vm.closeDetailKTGroupDialog()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }